import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

import { grey } from "@mui/material/colors";

const ChatSettingsTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} disableInteractive />
))(({ theme }) => ({
  fontWeight: "bold",
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: grey[900],
    color: "#FFF",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: "bold",
    border: "1px solid #dadde9",
  },
}));

export default ChatSettingsTooltip;
